import { Text, View } from '@mirai/ui';
import React from 'react';

import * as style from './routes.module.css';

export const Profile = () => (
  <>
    <View tag="section" className={[style.section, style.box, style.accent]}>
      <View className={style.wrapper}>
        <Text bold brand headline level={1}>
          Your profile
        </Text>
        <Text>Explore and manage your personal profile settings here.</Text>
      </View>
    </View>

    <View className={[style.wrapper, style.box]}>
      <View data-mirai-component="profile" />
    </View>
  </>
);
